import axiosInstance from "@/api/axiosInstance";

export interface ProductFormData {
  productCode: string;
  name: string;
  description: string;
  price: number;
  productType: string;
  isPublished: boolean;
  productCategoryId: number | null;
  thumbnailFileUuid: string | null;
}

export interface ProductListItem {
  id: number;
  uuid: string;
  productCode: string;
  name: string;
  description: string;
  isPublished: boolean;
  price: number;
  productType: string;
  thumbnailUrl: string | null;
  productCategoryName: string | null;
  createdAt: string | null;
  viewCount: number;
}

export const fetchProducts = async (params: Record<string, any>) => {
  const response = await axiosInstance.get("/api/private/products", { params });
  return response.data;
};

export const createProduct = async (data: ProductFormData) => {
  const response = await axiosInstance.post("/api/private/product/create", data);
  return response.data;
};

export const updateProduct = async (uuid: string, data: ProductFormData) => {
  const response = await axiosInstance.put(`/api/private/product/${uuid}/update`, data);
  return response.data;
};

export const deleteProduct = async (uuid: string) => {
  const response = await axiosInstance.delete(`/api/private/product/${uuid}/delete`);
  return response.data;
};

export const fetchProductByUuid = async (uuid: string) => {
  const response = await axiosInstance.get(`/api/private/product/${uuid}`);
  return response.data;
};

export const validateProductCode = async (code: string) => {
  const response = await axiosInstance.get(`/api/private/product/validate-code/${code}`);
  return response.data;
};
